import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { IDailyStockCount } from "../../models/wms/daily-stock-count";

dayjs.extend(utc);
dayjs.extend(timezone);
export const damascusNow = () => dayjs().tz("Asia/Damascus");
export const countDay = (now: Dayjs = damascusNow()) =>
  now.subtract(3, "hour").format("YYYY-MM-DD");
export const countTime = (day: string, time: string): string | null => {
  if (!time) return null;
  const date =
    time < "03:00"
      ? dayjs(`${day}T12:00:00`).add(1, "day").format("YYYY-MM-DD")
      : day;
  return dayjs
    .tz(`${date} ${time}`, "Asia/Damascus")
    .format("YYYY-MM-DDTHH:mm:ssZ");
};
export const latestCounts = (counts: IDailyStockCount[]) => {
  const result = new Map<number, IDailyStockCount>();
  for (const count of counts) {
    const previous = result.get(count.productId);
    const time = count.countedAt ? dayjs(count.countedAt).valueOf() : -Infinity;
    const oldTime = previous?.countedAt
      ? dayjs(previous.countedAt).valueOf()
      : -Infinity;
    if (
      !previous ||
      time > oldTime ||
      (time === oldTime && count.id > previous.id)
    )
      result.set(count.productId, count);
  }
  return result;
};
